import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Lookup } from 'projects/shared/src/models/lookup';
import { SystemModule } from '../../../features/central-hub/models/enums/SystemModule';

@Component({
  selector: 'app-custom-tree',
  standalone: false,
  templateUrl: './custom-tree.component.html'
})
export class CustomTreeComponent {
  @Input() recordsData: any;
  @Input() selectedId: any;
  @Output() eventEmit = new EventEmitter<any>();
  treeControl = new NestedTreeControl<Lookup>(node => node.child);
  dataSource = new MatTreeNestedDataSource<Lookup>();
  hasChild = (_: number, node: Lookup) => !!node.child && node.child.length > 0;
  @Input() viewOnly = false;
  systemModule = SystemModule;
  constructor() {
  }

  ngOnInit(): void {
    if (this.recordsData && this.recordsData.length) {
      this.dataSource.data = this.recordsData;
      if (this.selectedId) {
        const targetNode = this.findNodeById(this.dataSource.data, this.selectedId);
        if (targetNode) {
          this.expandParents(this.dataSource.data, targetNode);
        }
      }
    }
  }

  showDetails(node: Lookup) {
    console.log(node);

  }

  findNodeById(nodes: Lookup[], id: number): Lookup | null {
    for (let node of nodes) {
      if (node.id === id) {
        return node;
      }

      if (node.child?.length) {
        const found = this.findNodeById(node.child, id);
        if (found) return found;
      }
    }
    return null;
  }

  expandParents(nodes: Lookup[], target: Lookup, path: Lookup[] = []): boolean {
    for (let node of nodes) {
      const currentPath = [...path, node];

      if (node === target) {
        currentPath.forEach(n => this.treeControl.expand(n));
        return true;
      }

      if (node.child?.length) {
        const found = this.expandParents(node.child, target, currentPath);
        if (found) return true;
      }
    }
    return false;
  }

  action(node: Lookup, type: string) {
    this.eventEmit.emit({ type: type, data: node });
  }
}
